import ProfileAvatarIcon from "./ProfileAvatarIcon";

export default ProfileAvatarIcon;
